module.exports = __webpack_public_path__ + "img/v2hezi_logo.086deedf.png";